// copied as is from domino

import {__VOYAGER__, __latLongToVcid__, __VOYAGERX__} from '../../../../../../../src/shared/config/api-config';

export async function getPlacesId(suggestionArgument) {
  return new Promise(async (resolve, reject) => {
    // returns PROMISE with new suggestion
    const suggestion = suggestionArgument;
    const googlePlaceId =
      suggestion && suggestion.xtr && suggestion.xtr.ggl_id ? suggestion.xtr.ggl_id : '';
    if (googlePlaceId) {
      const searchParams = `nhood_id=${googlePlaceId}&id_type=ggl_id`;
      const voyagerUrlPlaces = `${__VOYAGERX__}${__latLongToVcid__}?${searchParams}`;

      let responseData = {};
      try {
        const resp = await fetch(voyagerUrlPlaces);
        const response = await resp.json();
        responseData = response.data;
      } catch (err) {
        responseData = {};
      }
      if (!Object.keys(responseData).length) {
        reject({message: 'Voyager Places API Failed'});
        return;
      }
      const placesSuggestion = responseData;
      const placeCity = placesSuggestion.city;
      const placeNhood = placesSuggestion.nhood;
      // put correct values in suggestion object
      suggestion._id = placeCity._id;
      suggestion.crd = placeNhood.crd && placeNhood.crd.length ? placeNhood.crd : placeCity.crd;
      suggestion.ct = {_id: placeCity._id, n: placeCity.n};
      suggestion.n = placeNhood.n;
      suggestion.isGooglePlace = true;
      suggestion.placeObject = placeNhood;

      resolve(suggestion);
    } else {
      reject({message: 'Google Place Id not present'});
    }
  });
}
